import BaseMutatinonTypes from 'baseapp/store/mutation-types'
let MutationTypes = {
  ...BaseMutatinonTypes,
  UPDATE_CONTRACT_COUNT: 'UPDATE_CONTRACT_COUNT',
  INIT_CONTRACT_COUNT: 'INIT_CONTRACT_COUNT',
  SET_ORDER_FILTERS: 'SET_ORDER_FILTERS',
  INIT_STORE: 'INIT_STORE',
  CLEAR_STORE: 'CLEAR_STORE',
  CLEAR_CUSTOM_COMPANY_CONFIG: 'CLEAR_CUSTOM_COMPANY_CONFIG'
}
export {
  MutationTypes
}



// WEBPACK FOOTER //
// ./src/apps/buyerapp/store/mutation-types.js